export default "__VITE_ASSET__D_koisH1__"